import { When } from 'react-if';
import { SparklingFillIcon } from '@zep-us/zus';
import { Chip } from '@zep-us/zus';
import { Colors, ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { BookCoverIcon } from '@/icons';
interface StandardCardBadgesProps {
  code: string;
  score?: number;
  showScore?: boolean;
}

/**
 * Badge area for StandardCard.
 * Shows achievement standard code badge (always) and recommendation score badge (when showScore is true).
 */
export const StandardCardBadges = ({
  code,
  score,
  showScore = false
}: StandardCardBadgesProps) => {
  const {
    t
  } = useTranslation(['build']);
  return <div className="flex flex-wrap gap-[6px]" data-sentry-component="StandardCardBadges" data-sentry-source-file="StandardCardBadges.tsx">
      {/* Recommendation Score Badge (recommendation tab only) */}
      <When condition={showScore && !!score} data-sentry-element="When" data-sentry-source-file="StandardCardBadges.tsx">
        <Chip size="sm" leftSlot={<SparklingFillIcon size="2xs" fill={Colors.Mint700} />} className="min-h-[22px] rounded-sm border-green-100 bg-green-50 text-green-700" data-sentry-element="Chip" data-sentry-source-file="StandardCardBadges.tsx">
          {t('build:build.standard.item.recommendBadge', {
          score
        })}
        </Chip>
      </When>

      {/* Achievement Standard Code Badge */}
      <Chip size="sm" leftSlot={<BookCoverIcon size="2xs" fill={ICON_COLOR.strong} />} className="min-h-[24px] rounded-sm border border-violet-100 bg-violet-50 text-caption-md-semibold text-strong" data-sentry-element="Chip" data-sentry-source-file="StandardCardBadges.tsx">
        {code}
      </Chip>
    </div>;
};